export type Transition = 'bottom-to-top' | 'top-to-bottom' | 'left-to-right' | 'right-to-left' | 'fade' | 'none';

export type Configurations = Record<Transition, string>;

export const transitions: Configurations = {
  fade: 'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 duration-150',
  'bottom-to-top': 'data-[state=open]:animate-in data-[state=open]:slide-in-from-bottom duration-150',
  'top-to-bottom': 'data-[state=open]:animate-in data-[state=open]:slide-in-from-top duration-150',
  'left-to-right': 'data-[state=open]:animate-in data-[state=open]:slide-in-from-left duration-150',
  'right-to-left': 'data-[state=open]:animate-in data-[state=open]:slide-in-from-right duration-150',
  none: '',
} as const;
